import React, { useCallback } from "react";
import { Paginator } from "primereact/paginator";
import "./css/NextGenPaginator.css";
import { Dropdown } from "primereact/dropdown";

const NextGenPaginator = ({
  first,
  rows,
  currentPage,
  totalRecords,
  rowsPerPageOptions,
  onPageChange,
}) => {
  const CurrentPageReport = () => {
    return <span className="p-paginator-current-page">{currentPage + 1}</span>;
  };
  const RowsPerPageDropdown = (options) => {
    return (
      <div className="p-paginator-rows-per-page">
        <label
          htmlFor="rowsPerPageDropdown"
          className="p-paginator-rows-per-page-label"
        >
          Rows per page
        </label>
        <Dropdown
          id="rowsPerPageDropdown"
          {...options}
          className="p-paginator-rows-per-page-dropdown"
        />
      </div>
    );
  };

  const customTemplate = {
    layout: "PrevPageLink CurrentPageReport NextPageLink RowsPerPageDropdown",
    CurrentPageReport: CurrentPageReport,
    RowsPerPageDropdown: RowsPerPageDropdown,
  };

  return (
    <Paginator
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPageChange={onPageChange}
      template={customTemplate}
      rowsPerPageOptions={rowsPerPageOptions}
    />
  );
};

export default NextGenPaginator;
